<template>
  <div class="mb-5">
    <router-link :to="{name: 'terms-of-service.list'}">See other terms</router-link>
    <div class="text-center">
      <h2>Livestream <br>(iOS/Android App)</h2>
    </div>

    <hr />
    <div>
      <p>Effective Date: 14/03/2024</p>
    </div>
    <hr />

    <div>
      <h3>1. Introduction</h3>
      <p>Welcome to OpenMasjid Livestream ("App"). These Terms of Service ("Terms") govern your use of the App, which includes both the native mobile application and the iframe version ("Iframe") that can be embedded on external websites. The App is owned and operated by OpenMasjid.io ("we," "us," or "our"). By accessing or using the App, you agree to be bound by these Terms. If you disagree with any part of these Terms, you may not access or use the App.</p>
    </div>
    <hr />

    <div>
      <h3>2. Use of the App</h3>
      <p><strong>2.1</strong> You must be at least 13 years old to use the App. By using the App, you represent and warrant that you are at least 13 years old and of legal capacity to enter into a binding agreement.</p>
      <p><strong>2.2</strong> You are responsible for maintaining the confidentiality of your account information and password. You are also responsible for all activity that occurs under your account.</p>
      <p><strong>2.3</strong> You agree to use the App in accordance with all applicable laws and regulations.</p>
      <p><strong>2.4</strong> You agree not to use the App for any purpose that is unlawful or unauthorized. This includes, but is not limited to:</p>
      <ul>
        <li>Infringing on the intellectual property rights of others.</li>
        <li>Transmitting any harmful or malicious code, such as viruses or worms.</li>
        <li>Interfering with or disrupting the App or any servers or networks connected to the App.</li>
        <li>Impersonating any person or entity.</li>
        <li>Collecting or storing personal information about other users without their express consent.</li>
      </ul>
    </div>
    <hr />

    <div>
      <h3>3. Intellectual Property</h3>
      <p>The App and all content and materials included in the App (including, but not limited to, text, graphics, logos, images, and software) are the property of OpenMasjid.io or its licensors and are protected by copyright, trademark, and other intellectual property laws.</p>
    </div>
    <hr />

    <div>
      <h3>4. Disclaimers</h3>
      <p>THE APP IS PROVIDED "AS IS" AND WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. WE DISCLAIM ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE APP WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE APP IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.</p>
    </div>
    <hr />

    <div>
      <h3>5. Iframe Data Collection</h3>
      <p>The Iframe may use cookies to maintain session state and improve user experience. These cookies are temporary and do not contain any personally identifiable information (PII).</p>
    </div>
    <hr />

    <div>
      <h3>6. Limitation of Liability</h3>
      <p>WE WILL NOT BE LIABLE FOR ANY DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE APP, INCLUDING, BUT NOT LIMITED TO, DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES.</p>
    </div>
    <hr />

    <div>
      <h3>7. Termination</h3>
      <p>We may terminate your access to the App at any time for any reason, with or without notice.</p>
    </div>
    <hr />

    <div>
      <h3>8. Governing Law</h3>
      <p>These Terms shall be governed by and construed in accordance with the laws of the United Kingdom, without regard to its conflict of law provisions.</p>
    </div>
    <hr />

    <div>
      <h3>9. Entire Agreement</h3>
      <p>These Terms constitute the entire agreement between you and us regarding your use of the App.</p>
    </div>
    <hr />

    <div>
      <h3>10. Severability</h3>
      <p>If any provision of these Terms is held to be invalid or unenforceable, such provision shall be struck and the remaining provisions shall remain in full force and effect.</p>
    </div>
    <hr />

    <div>
      <h3>11. Changes to these Terms</h3>
      <p>We may update these Terms at any time. We will notify you of any changes by posting the new Terms on the App. You are advised to consult these Terms regularly for any changes. By continuing to use the App after the revised Terms are posted, you agree to be bound by the new Terms.</p>
    </div>
    <hr />

    <div>
      <h3>Contact Us</h3>
      <p>If you have any questions about this Privacy Policy, please contact us at:<br /> <a href="mailto:talha@arcticprism.com">talha@arcticprism.com.</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LivestreamTermsOfService"
}
</script>

<style scoped>

</style>